import type { ThemeState } from '@atlaskit/tokens';

import { fg } from '@confluence/feature-gating';

export const getDefaultTheme = (): Partial<ThemeState> => {
	return {
		dark: 'dark',
		light: 'light',
		colorMode: 'light',
		typography: fg('confluence_typography_refreshed')
			? 'typography-refreshed'
			: 'typography-modernized',
	};
};
